(function () {
  var ENDPOINT = window.__errorTrackingEndpoint;
  var THROTTLE_KEY = 'ss_err_last';
  var THROTTLE_MS = 60000; // Max one report per minute

  function shouldReport() {
    try {
      var last = parseInt(sessionStorage.getItem(THROTTLE_KEY) || '0', 10);
      if (Date.now() - last < THROTTLE_MS) return false;
      sessionStorage.setItem(THROTTLE_KEY, Date.now().toString());
      return true;
    } catch (e) {
      return true;
    }
  }

  function report(data) {
    if (!ENDPOINT || !shouldReport()) return;
    data.url = window.location.href;
    data.ua = navigator.userAgent;
    data.time = new Date().toISOString();
    try {
      navigator.sendBeacon(ENDPOINT, JSON.stringify(data));
    } catch (e) {
      // silent
    }
  }

  // Catch unhandled JS errors
  window.addEventListener('error', function (e) {
    report({
      type: 'js_error',
      message: e.message || 'Unknown error',
      source: e.filename || '',
      line: e.lineno || 0,
      col: e.colno || 0
    });
  });

  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', function (e) {
    report({
      type: 'promise_rejection',
      message: e.reason ? (e.reason.message || String(e.reason)) : 'Unknown rejection'
    });
  });

  // Catch failed network requests (images, scripts, stylesheets)
  window.addEventListener('error', function (e) {
    var tag = e.target && e.target.tagName;
    if (tag === 'IMG' || tag === 'SCRIPT' || tag === 'LINK') {
      report({
        type: 'resource_error',
        tag: tag,
        src: e.target.src || e.target.href || ''
      });
    }
  }, true);

  // Monitor Add to Cart form submissions for failures
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id === 'product-form' || form.action.indexOf('/cart/add') !== -1) {
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) {
        report({
          type: 'cart_error',
          message: 'Add to cart submitted without variant ID'
        });
      }
    }
  });

  // Monitor fetch failures for cart API
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var url = arguments[0];
      if (typeof url === 'string' && (url.indexOf('/cart') !== -1 || url.indexOf('/checkout') !== -1)) {
        return originalFetch.apply(this, arguments).then(function (response) {
          if (!response.ok) {
            report({
              type: 'api_error',
              endpoint: url,
              status: response.status,
              message: response.statusText
            });
          }
          return response;
        }).catch(function (err) {
          report({
            type: 'api_error',
            endpoint: url,
            message: err.message || 'Network error'
          });
          throw err;
        });
      }
      return originalFetch.apply(this, arguments);
    };
  }
})();
